<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết tiểu mục công việc</h1>
      <div style="float: right">
        <button
          @click="$router.push({ path: `/work-subsection-afs` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3">
          <div class="form-detail">
            <h1>Thông tin tiểu mục công việc</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã tiểu mục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.code }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên tiểu mục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.name }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <b-badge :variant="detail.isActive ? 'success' : 'danger'" size="sm">
                    {{ detail.isActive ? 'Đang áp dụng' : 'Đã khóa' }}
                  </b-badge>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Danh mục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.taskName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã danh mục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.taskCode }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.groupName">
              <label for="" class="col-sm-4 col-form-label"
                >Nhóm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.groupName }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  export default {
    data() {
      return {
        id: this.$route.params.id,
        detail: {},
      }
    },
    created() {
      if (this.id) {
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          const data = await CalendarAfsService.getDetailWorkSubsection(this.id)
          if (data.success) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
